import $ from 'jquery'

function manyWaysPlayer($element) {

  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      $container,
      manyWaysWidth,
      $arrowNext,
      $arrowPrev,
      $manyWaysAllLine,
      manyWaysLeft,
      manyWaysCount,
      indexTutorialPlus,
      indexTutorialMinus,
      timer;

  /* PRIVATE METHODS */

  // constructor
  function init() {
    $container = $('.flexible-playlistorial-page');
    $arrowNext = $('.many-ways-next', $mainContainer);
    $arrowPrev = $('.many-ways-prev', $mainContainer);
    $manyWaysAllLine = $('.many-ways-all-items', $mainContainer);
    manyWaysLeft = parseInt($manyWaysAllLine.css('left'));
    manyWaysCount = $('.many-ways-tutorial', $mainContainer).length;

    bindDomEvents();
    updatePosition();
  }

  function bindDomEvents() {
    manyWaysSlider();
    bindPositionChangeToggle();

    if ($('.many-ways-tutorial.current').index() > 3) {
      indexTutorialMinus = $('.many-ways-tutorial.current').index() - 3;
      indexTutorialPlus = manyWaysCount - $('.many-ways-tutorial.current').index() - 1;
    } else {
      indexTutorialMinus = 0;
      indexTutorialPlus = manyWaysCount - 4;
    }

    $(window).on('resize', function() {
      clearTimeout(timer);
      timer = setTimeout(function() {

        $manyWaysAllLine.animate({'left': '0'});
        $arrowPrev.addClass('disabled');

        var manyWaysWidth = $('.many-ways-wrapper', $mainContainer).width();
        var manyWayWidth = manyWaysWidth * 0.25,
            bordersWidth = manyWaysCount + 1;

        $('.many-ways-all-items').width(manyWayWidth * manyWaysCount + bordersWidth);
        $('.many-ways-tutorial', $mainContainer).width(manyWayWidth);

        if ($('.many-ways-tutorial.current').index() > 3) {
          manyWaysCurrent(manyWayWidth);
        }
      }, 300);
    });

    $('.many-ways-tutorial', $mainContainer).on('mouseenter', function(){
      var $this = $(this);

      $('.stars', $this).append('<div class="stars-inner"></div>');
    }).on('mouseleave', function() {
      var $this = $(this);
      $('.stars-inner', $this).remove();
    });
  }

  function bindPositionChangeToggle() {
    $(window).on('scroll', function () {
      updatePosition();
    });
  }

  function manyWaysSlider() {
    manyWaysWidth = $('.many-ways-wrapper', $mainContainer).width();
    $('.many-ways-tutorial', $mainContainer).width(manyWaysWidth * .25);
    var manyWasItemWidth = $('.many-ways-tutorial', $mainContainer).width(),
        bordersWidth = manyWaysCount + 1;

    $manyWaysAllLine.width(manyWasItemWidth * manyWaysCount + bordersWidth);

    if ($('.many-ways-tutorial.current').index() > 3) {
      manyWaysCurrent(manyWasItemWidth);
    } else {
      $arrowPrev.addClass('disabled');
    }

    $arrowNext.on('click', function() {
      var $arrow = $(this),
          manyWaysAllWidth = $manyWaysAllLine.width();
      if (!$arrow.hasClass('disabled') && indexTutorialPlus > 0) {

        manyWaysLeft = parseInt($manyWaysAllLine.css('left'));
        var manyWaysLastPosition = (0 - manyWaysAllWidth) + manyWasItemWidth * 4 + bordersWidth;
        $manyWaysAllLine.animate({'left': '-=' + manyWasItemWidth});
        $arrowPrev.removeClass('disabled');

        if ((manyWaysLeft - manyWasItemWidth) <= manyWaysLastPosition) {
          $arrow.addClass('disabled');
        }

        indexTutorialPlus -= 1;
        indexTutorialMinus += 1;
      }
    });

    $arrowPrev.on('click', function() {
      var $arrow = $(this);
      if (!$arrow.hasClass('disabled') && indexTutorialMinus > 0) {
        $manyWaysAllLine.animate({'left': '+=' + manyWasItemWidth});
        $arrowNext.removeClass('disabled');

        manyWaysLeft = parseInt($manyWaysAllLine.css('left'));

        if (manyWaysLeft >= (0 - manyWasItemWidth)) {
          $manyWaysAllLine.animate({'left': '0'});
          $arrow.addClass('disabled');
        }

        indexTutorialPlus +=1;
        indexTutorialMinus -= 1;
      }
    });
  }

  function manyWaysCurrent(width) {
    var index = $('.many-ways-tutorial.current').index(),
        moveToLeft = (index + 1) - 4;

    $arrowPrev.removeClass('disabled');
    $manyWaysAllLine.animate({'left': '-=' + (moveToLeft * width)});

    if ((index + 1) == manyWaysCount) {
      $arrowNext.addClass('disabled');
    }
  }

  function updatePosition() {
    var containerOffsetTop = parseInt($container.offset().top, 10),
        mainContainerHeight = parseInt($mainContainer.outerHeight(), 10),
        documentScrollTop = parseInt($(window).scrollTop(), 10);

    var positionFix = documentScrollTop - containerOffsetTop + mainContainerHeight,
        positionScroll = documentScrollTop - containerOffsetTop;

    if (positionFix > 0 ) {
      $mainContainer.removeClass('stop');
    } else {
      $mainContainer.addClass('stop');
    }

    if (positionScroll > 0) {
      $('.with-many-ways').css('padding-top', mainContainerHeight);
    } else {
        $('.with-many-ways').css('padding-top', '0');
    }
  }

  // run constructor
  init();

  /* PUBLIC METHODS */

  return {
  }
}

// jQuery plugin method
$.fn.manyWaysPlayer = function() {
  return this.each(function() {
    var $this = $(this);

    // Store plugin object in this element's data if it doesn't already exist
    if (!$this.data('manyWaysPlayer')) {
      $this.data('manyWaysPlayer', manyWaysPlayer($this));
    }
  });
};
